// 사업자 정보 설정 섹션 URL (2026-08-07 KST 추가)
const businessInfoSettingsSection = "/business-info-settings";

export const businessInfoSettingsPath = businessInfoSettingsSection;
